import React from "react";
import { Modal, Button } from "react-bootstrap";
import SuccessIcon from "../../../../assets/img/success-icon.png";
import "./video.scss";

export const ModalVideoComponent = ({
  visible = false,
  onToggle,
  availableDays = "",
}) => {
  return (
    <Modal
      show={visible}
      centered
      className="video-modal"
      dialogClassName="video-modal-dialog"
      aria-labelledby="video-modal-title"
      onHide={onToggle}
    >
      <Modal.Body className="video-modal-body">
        <img
          src={SuccessIcon}
          alt="Video generado"
          className="video-modal-icon"
        />
        <h2 id="video-modal-title" className="video-modal-title">
          Estamos generando el video
        </h2>
        <p className="video-modal-description">
          Recuerde que el mismo tendrá una vigencia de {availableDays} días,
          pasado ese lapso deberá volver a generarlo.
        </p>
        <Button
          type="button"
          className="video-modal-accept"
          onClick={onToggle}
        >
          Aceptar
        </Button>
      </Modal.Body>
    </Modal>
  );
};
